import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ListingCard } from "@/components/ListingCard";

export default function SavedPage() {
  const { user, setAuthOpen } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => { if (user === false) setAuthOpen(true); }, [user, setAuthOpen]);
  useEffect(() => { if (user && user !== false) api.get("/favorites").then((r) => setItems(r.data)).catch(() => {}); }, [user]);

  if (!user || user === false) return <div className="p-8 text-center text-slate-500">Kyçu për të parë të ruajturat.</div>;

  return (
    <div className="gs-fade px-4 pt-4">
      <h1 className="flex items-center gap-2 text-2xl font-extrabold text-slate-900 mb-3"><Heart className="w-6 h-6 text-red-500" />Të ruajturat</h1>
      {items.length ? (
        <div className="grid grid-cols-2 gap-3">{items.map((l) => <ListingCard key={l.id} listing={l} saved onToggleSaved={(id, s) => !s && setItems((p) => p.filter((x) => x.id !== id))} />)}</div>
      ) : <p className="text-center text-slate-400 py-10">Ende pa shpallje të ruajtura.</p>}
    </div>
  );
}
